import React from "react";
import "./CyberSecurity.css";
import Floaticons from "./Floaticons";
import MenuNavbar from "./MenuNavbar";
import Link from '@mui/material/Link';
import HomeIcon from '@mui/icons-material/Home';
import { Breadcrumbs } from "@material-ui/core";
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import mailData from '../data/mailData.js';

function Cybersecurity() {
    return (
        <>
            <div className="banner-container">
                <img src="images/Cybersecurity/Security-Banner.png" alt="banner" className="banner-img" />
                <div className="breadcrumbs-container">
                    <Breadcrumbs separator=">" color="#fff">
                        <Link
                            underline="hover"
                            sx={{ display: 'flex', alignItems: 'center' }}
                            color="#fff"
                            href="/"
                        >
                            <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        </Link>,
                        <Link
                            underline="hover"
                            key="2"
                            color="#fff"
                            href="/keyInitiatives"
                        // onClick={handleClick}
                        >
                            Key Initiatives
                        </Link>,
                        <Typography key="3" color="#fff">
                            Cybersecurity Essentials for Beginners
                        </Typography>,
                    </Breadcrumbs>
                </div>
                
                <div className="banner-content">
                    <h1>Cybersecurity Essentials for Beginners</h1>
                    <i>Lorem ipsum is simply  dummy text of the printing and typesetting industry</i>
                </div>
            </div>

            <div className="cybersecurity-main-container">

                {/* Section 1  */}
                <div className="about-security-container">
                    <div className="about-security-wrap">
                        <div className="about-security-row">
                            <div className="about-security-box box1">
                                <img src="images/Cybersecurity/about.png" alt="about-img" className="about-img" />
                            </div>
                            <div className="about-security-box box2">
                                <h2>About the Program</h2>
                                <p>This program is exclusively designed for the professionals interested in starting their journey as Cybersecurity Professionals. It aims to provide a comprehensive understanding of various concepts used in the world of information security. This course will help you build key skills needed to recognize common security threats and risks, discover the characteristics of cyber-attacks, and learn how organizations employ best practices to guard against them.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* section 2  */}
                <div className="design-container">
                    <div className="design-wrap">
                        <h2>Program Design</h2>
                        <p>The program dives into specializations such as Secure SDLC, IAM, Application Security, Data Security, Cloud Security, and different vulnerabilities. The duration of the course is 25 hours and is a blend of self-paced learnings, two SME connects, Hands-on Labs and assessments.</p>
                        <div className="design-row">
                            <div className="design-box box1">
                                <img src="images/Cybersecurity/new-design11.png" alt="design-outbox" className="design-outimg" />
                                <h3>Secure SDLC</h3>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            <ul className="accord-lists">
                                                <li>Secure Requirements</li>
                                                <li>Software Development Security</li>
                                                <li>Secure Programmer: Intro to Programming Standards</li>
                                                <li>Secure Testing</li>
                                            </ul>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        </div>
                        <div className="design-row">
                            <div className="design-box box2">
                                <img src="images/Cybersecurity/new-design12.png" alt="design-outbox" className="design-outimg" />
                                <h3>Identity & Access Management</h3>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            <ul className="accord-lists">
                                                <li>Authentication & Authorization Concepts</li>
                                                <li>Authentication & Encryption: Best Practices</li>
                                                <li>Identity & Access Management Controls</li>
                                            </ul>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        </div>
                        <div className="design-row">
                            <div className="design-box box3">
                                <img src="images/Cybersecurity/new-design13.png" alt="design-outbox" className="design-outimg" />
                                <h3>Application Security</h3>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            <ul className="accord-lists">
                                                <li>Software Security Best Practices</li>
                                                <li>Introduction to Secure Programming</li>
                                                <li>Security Programming: System Essentials</li>
                                                <li>Application Development & Security</li>
                                            </ul>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        </div>
                        <div className="design-row">
                            <div className="design-box box4">
                                <img src="images/Cybersecurity/new-design14.png" alt="design-outbox" className="design-outimg" />
                                <h3>Data Security</h3>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            <ul className="accord-lists">
                                                <li>Data Classification & Monitoring</li>
                                                <li>Data Privacy</li>
                                                <li>Encryption & Malware</li>
                                                <li>Data Access & Monitoring Governance Policies</li>
                                            </ul>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        </div>
                        <div className="design-row">
                            <div className="design-box box5">
                                <img src="images/Cybersecurity/new-design15.png" alt="design-outbox" className="design-outimg" />
                                <h3>Cloud Security</h3>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            <ul className="accord-lists">
                                                <li>Cloud Security Fundamentals</li>
                                                <li>Cloud Architectural & Design Concepts</li>
                                                <li>Cloud Data Security</li>
                                                <li>Cloud Access Control</li>
                                                <li>Cloud Risk Management</li>
                                            </ul>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        </div>
                        <div className="design-row">
                            <div className="design-box box6">
                                <img src="images/Cybersecurity/new-design16-new.png" alt="design-outbox" className="design-outimg" />
                                <h3>Threat & Vulnerability Management</h3>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            <ul className="accord-lists">
                                                <li>Understanding Security Threats</li>
                                                <li>Security Vulnerabilities: Managing Threats & Vulnerabilities</li>
                                                <li>Social Engineering & Related Attacks</li>
                                                <li>Pen Testing & Vulnerability Scanning</li>
                                                <li>Identifying & Reducing Vulnerabilities</li>
                                            </ul>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        </div>
                        <img src="images/Cybersecurity/Design-arrow.png" alt="design-flow" className="design-flow-img" />
                    </div>
                </div>

                {/* section 3  */}
                <div className="details-container">
                    <div className="details-wrap">
                        <h2>Program Details</h2>
                        <p><b>Course Completion Criteria</b> - Completion of all module-based assessments with score of <b>70%</b> & above and Program Final Assessment with score of <b>60%</b> & above.
                        </p>
                        <div className="details-row">
                            <div className="details-box">
                                <img src="images/Cybersecurity/Cybersecurity-Flair.gif" alt="badge" className="badge-icon" />
                                <p><b>Complete the program and earn your badge on people's page</b>
                                </p>
                            </div>
                        </div>
                        <p> For any queries, please reach out to <b>{`${mailData.securityindlearning}`}</b>
                        </p>
                    </div>
                </div>

            </div>
            <Floaticons />
        </>
    );
}

export default Cybersecurity;
